module.exports = __webpack_public_path__ + "media/images/hand_submission-6aceb873.svg";